import { Button } from '@library/buttons/Button';

import { Prompt } from '../../shared/Prompt';
import { PromptContent } from '../../shared/PromptContent';
import { PromptHeader } from '../../shared/PromptHeader';

type Props = {
  email: string;
  onSubmit: () => void;
};

export const ExistingAccountView = ({ email, onSubmit }: Props) => (
  <Prompt data-cy="existing-account-form" variant="auth">
    <PromptHeader
      logoType="icon"
      title="Let's get you in..."
      subtitle={
        <>
          <div>
            It looks like you&apos;ve previously created an account for&nbsp;
            <span
              style={{
                wordBreak: 'break-all',
                fontWeight: 'bold',
              }}
            >
              {email}.
            </span>
          </div>
        </>
      }
    />
    <PromptContent>
      <Button isPrimary data-cy="login-btn" type="submit" onClick={onSubmit}>
        Continue
      </Button>
    </PromptContent>
  </Prompt>
);
